import { signOut } from "aws-amplify/auth";
import { useCallback, useContext } from "react";
import { UserTypeContext } from "../contexts/UserTypeContext";
import { RoutePaths } from "../enumStrings";
import {
  getSignOutReasonQuery,
  isSignOutReason,
  SignOutReason,
} from "../components/pages/Auth/signOutReasons";

export const useHandleLogout = () => {
  const {
    setters: { setUserType },
  } = useContext(UserTypeContext);

  // A reason is passed only when the dashboard signs the user out by itself,
  // so the Sign in page can say why. A button click passes an event, which is
  // not a reason.
  const handleLogout = useCallback(
    async (reason?: SignOutReason | unknown): Promise<void> => {
      try {
        await signOut();
      } catch (error) {
        console.log(error);
      }

      sessionStorage.clear();

      setUserType(null);

      window.location.href = `${RoutePaths.login}${getSignOutReasonQuery(
        isSignOutReason(reason) ? reason : undefined
      )}`;
    },
    [setUserType]
  );

  return handleLogout;
};
